import React, { useState } from 'react';
import { AgxDatePicker, AgxRow } from '@urbanx/agx-ui-components';
import './DateRangeSelector.scss';

interface DateRangeSelectorProps {
  startDate: string;
  endDate: string;
  onChange: (startDate: string, endDate: string) => void;
}

const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({
  startDate,
  endDate,
  onChange,
}) => {
  const [localStartDate, setLocalStartDate] = useState(startDate);
  const [localEndDate, setLocalEndDate] = useState(endDate);

  const handleStartDateChange = (value: string) => {
    setLocalStartDate(value);
    onChange(value, localEndDate);
  };

  const handleEndDateChange = (value: string) => {
    setLocalEndDate(value);
    onChange(localStartDate, value);
  };

  return (
    <AgxRow fill veryLargeGap>
      <AgxDatePicker
        id="networkDateStart"
        extraClasses="agxDatePickerConstrained"
        date
        noOptionalLabel
        stretch
        defaultValue={localStartDate}
        onValueChanged={e => handleStartDateChange(e.value)}
      />
      <AgxDatePicker
        id="networkDateEnd"
        extraClasses="agxDatePickerConstrained"
        date
        noOptionalLabel
        stretch
        defaultValue={localEndDate}
        onValueChanged={e => handleEndDateChange(e.value)}
      />
    </AgxRow>
  );
};

export default DateRangeSelector;
